import { AuthStepPanel } from '@/features/authentication/components/AuthStepPanel';

type HomeEmailDiscoveryStepProps = {
  animationKey: string;
  email: string;
  showPlaceholder: boolean;
  isDiscovering: boolean;
  authError: string;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onEmailFocus: () => void;
  onEmailBlur: () => void;
  onEmailChange: (value: string) => void;
};

export const HomeEmailDiscoveryStep = ({
  animationKey,
  email,
  showPlaceholder,
  isDiscovering,
  authError,
  onSubmit,
  onEmailFocus,
  onEmailBlur,
  onEmailChange,
}: HomeEmailDiscoveryStepProps) => {
  return (
    <AuthStepPanel
      animationKey={animationKey}
    >
      <form className="flex flex-col gap-4" onSubmit={onSubmit}>
        <div className="flex flex-col gap-2">
          <label htmlFor="email" className="font-termina text-sm uppercase tracking-[0.12em] text-white">
            Email Address
          </label>
          <input
            id="email"
            className="w-full rounded-[1.75rem] px-5 py-3.5 font-termina text-base text-slate-900 md:max-w-[26rem]"
            type="email"
            placeholder={showPlaceholder ? 'Email address' : ''}
            value={email}
            onFocus={onEmailFocus}
            onBlur={onEmailBlur}
            onChange={(event) => onEmailChange(event.target.value)}
          />
        </div>

        {authError && <p className="font-termina text-sm text-red-200">{authError}</p>}

        <button
          className="w-max rounded-[1.75rem] bg-[#E2A807] px-6 py-3 font-termina font-black uppercase text-slate-950 transition-all duration-200 hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-60"
          type="submit"
          disabled={isDiscovering || !email.trim()}
        >
          Continue
        </button>
      </form>
    </AuthStepPanel>
  );
};
